export const clearImage = (image: string): string => {
    if (image.indexOf('base64,') > 0) {
        const parts = image.split('base64,');
        return parts[1]
    }
    return image
}
